<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refLineInterruptionList'
        :data-source='lineInterruptionList'
        :show-borders="true"
        :height='gridHeight'
        :allowColumnResizing = 'true' :allow-column-reordering = "true"
        :selection="{ mode: 'single' }"
        @toolbar-preparing='onToolbarPreparing'
        @editor-preparing='onEditorPreparingDate'
        @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated' @row-updating='onRowUpdating'
        @rowDblClick ='onRowDbClick'
        :key-expr="['라인코드','시작시간']"
      >
      <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="라인중단등록"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
      <DxEditing
        :allow-updating="true"
        :allow-adding="true"
        :allow-deleting="true"
        :use-icons="true"
        :mode='editMode'
      />
      <DxPaging :enabled="false"/>
      <DxColumn
        :allowEditing='isEdit'
        :width="100"
        data-field="라인코드"
        caption="라인명"
        :fixed="true"
      >
        <DxLookup
            :data-source='lineinfoList'
            value-expr="라인코드"
            display-expr="라인명"
          />
          <dx-required-rule message="항목을 입력하세요"/>
      </DxColumn>
      <DxColumn
        data-field="중단원인"
      >
        <DxLookup
          :data-source="중단원인"
          value-expr="코드"
          display-expr="코드명"
        />
        <DxFormItem
          :col-span="2"
        />
        <dx-required-rule message="항목을 입력하세요"/>
      </DxColumn>
      <DxColumn
        :allowEditing='isEdit'
        data-field="시작시간"
        caption="중단시작시간"
        data-type="datetime"
        format='yyyy-MM-dd HH:mm'
        :fixed="true"
      >
        <dx-required-rule message="항목을 입력하세요"/>
      </DxColumn>
      <DxColumn
        data-field="종료시간"
        caption="중단종료시간"
        data-type="datetime"
        format='yyyy-MM-dd HH:mm'
        :fixed="true"
      >
        <dx-required-rule message="항목을 입력하세요"/>
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        data-field="중단시간"
        :calculate-cell-value="calculateDowntime"
      >
      <DxFormItem
          :visible='false'
        />
      </DxColumn>
      <DxColumn
        :visible="true"
        data-field="비고"
        :min-width="500"
      >
        <DxFormItem
          :col-span="2"
          :editor-options="{ height: 100 }"
          editor-type="dxTextArea"
        />
      </DxColumn>
      <DxSummary>
        <DxTotalItem
          value-format='#,##0'
          show-in-column="라인명"
          display-format="{0} (건)"
        />
       </DxSummary>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, {
  DxColumn,
  DxFormItem,
  DxPaging,
  DxEditing,
  DxLookup,
  DxSearchPanel,
  DxFilterRow,
  DxExport,
  DxSummary,
  DxTotalItem,
  DxScrolling,
  DxSorting
} from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import 'devextreme-vue/text-area'
import AppLib from '../../share/AppLib'

export default {
  name: 'lineInterruption',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '라인중단등록'
        }
      ],
      lineinfoList: null,
      lineInterruptionList: null,
      yearArray: [],
      thisYear: null,
      isEdit: true,
      중단원인: null,
      editMode: 'form'
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxFormItem,
    DxPaging,
    DxEditing,
    DxLookup,
    DxSearchPanel,
    DxFilterRow,
    DxExport,
    DxRequiredRule,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxSorting
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2020; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.중단원인 = this.$store.getters.getBaseDataByType(ConstDef.라인중단코드)
    const index = this.$_.findIndex(this.중단원인, { 코드: ConstDef.설비중단코드 })
    this.중단원인.splice(index, 1)
    this.refreshLineinfoList()
    this.refreshLineInterruptionList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateDowntime (row) {
      if (row.종료시간 === null || row.종료시간 === undefined) {
        return null
      }
      let diff = (row.종료시간 - row.시작시간) / 1000 / 60
      if (diff < 60) {
        return `${diff}분`
      } else if (diff < (24 * 60)) {
        return `${(diff / 60).toFixed(1)}시간`
      } else {
        const day = Math.floor(diff / 60 / 24)
        let hr = diff - (day * 60 * 24)
        hr = Math.ceil(hr / 60)
        return `${day}일 ${hr}시간`
      }
    },
    onRowDbClick (row) {
      // this.editMode = 'form'
      this.$refs.refLineInterruptionList.instance.editRow(row.rowIndex)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshLineInterruptionList()
            }
          }
        }
      )
    },
    onEditorPreparingDate (e) {
      if (e.dataField === '시작시간' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isEdit = true
        } else {
          this.isEdit = false
        }
      }
    },
    onRowInserting (row) {
      if (row.data.시작시간 !== null && (typeof row.data.시작시간) === 'object') {
        row.data.시작시간 = row.data.시작시간.getTime()
      }
      if (row.data.종료시간 !== null && (typeof row.data.종료시간) === 'object') {
        row.data.종료시간 = row.data.종료시간.getTime()
      }
      if (row.data.시작시간 >= row.data.종료시간) {
        this.$snotify.info('종료시간을 확인하여주세요')
        row.cancel = true
      }
    },
    onRowInserted (row) {
      row.data.updateid = row.data.createid = this.userInfo.userName
      this.$_sp.runInsertSqlProc('라인중단', ['라인명', '중단시간'], [row.data])
        .then((data) => {
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowUpdating (row) {
      if (row.newData.종료시간 !== undefined && row.newData.종료시간.length > 0) {
        if (row.newData.종료시간 !== null && (typeof row.newData.종료시간) === 'object') {
          row.newData.종료시간 = row.newData.종료시간.getTime()
        }
      }
      if (row.oldData.시작시간 >= row.newData.종료시간) {
        this.$snotify.info('종료시간을 확인하여주세요')
        row.cancel = true
      }
    },
    onRowUpdated (row) {
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      this.$_sp.runUpdateSqlProc('라인중단', ['라인코드', '시작시간'], ['createid', 'createtime', '라인명', '중단시간'], [row.data])
        .then((date) => {
          this.$snotify.info('수정되었습니다.')
        })
        .catch(error => {
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoved (row) {

    },
    refreshLineinfoList () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.lineinfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    refreshLineInterruptionList () {
      this.$_sp.runNoEncodeFindProc('spFindAllLineInterruptionByYear', { year: this.thisYear })
        .then((data) => {
          this.lineInterruptionList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    }
  }
}

</script>

<style lang="scss">

</style>
